import React, { ReactElement } from 'react'
import { StyledButtonSecondary, StyledCaptionSpan } from './Button.secondary.styles'

export interface IButtonSecondaryProps {
  onClick: () => void;
  text: string;
  caption?: string;
  weight?: 'normal' | 'bold';
  justify?: 'stretch' | 'center' | 'left' | 'right';
}

const ButtonSecondary = ({ onClick, text, caption, justify }: IButtonSecondaryProps): ReactElement => {
  return (
    <StyledButtonSecondary onClick={onClick} justify={justify}>
      <span>
        {text}
      </span>
      {
        caption ?
          <StyledCaptionSpan>
            {caption}
          </StyledCaptionSpan>
          : null
      }
    </StyledButtonSecondary>
  )
}

export default ButtonSecondary;
